import { render, staticRenderFns } from "./CalendarCodeItem.vue?vue&type=template&id=d5c38116&scoped=true"
import script from "./CalendarCodeItem.vue?vue&type=script&lang=js"
export * from "./CalendarCodeItem.vue?vue&type=script&lang=js"
import style0 from "./CalendarCodeItem.vue?vue&type=style&index=0&id=d5c38116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_cache-loader@4.1.0_webpack@4.47.0__css-load_163004cd90115b55449e6d2350f1be1c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c38116",
  null
  
)

export default component.exports